import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCourses } from '../../services/courses';
import { useAuth } from '../../context/AuthContext';
import Card, { CardBody } from '../ui/Card';
import Badge from '../ui/Badge';
import Button from '../ui/Button';

export default function TeacherDashboard() {
    const { user } = useAuth();
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCourses()
            .then((res) => setCourses(res.data.data || []))
            .finally(() => setLoading(false));
    }, []);

    const totalStudents = courses.reduce((sum, c) => sum + (c.enrollments_count || 0), 0);
    const publishedCourses = courses.filter((c) => c.status === 'published').length;

    if (loading) {
        return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" /></div>;
    }

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900">Salom, {user?.name}!</h1>
                    <p className="text-gray-500 text-sm mt-1">O'qituvchi paneli</p>
                </div>
                <Link to="/teacher/courses/create">
                    <Button>+ Yangi kurs</Button>
                </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <Card>
                    <CardBody>
                        <p className="text-sm text-gray-500">Jami kurslar</p>
                        <p className="text-3xl font-bold text-gray-900 mt-1">{courses.length}</p>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <p className="text-sm text-gray-500">Nashr qilingan</p>
                        <p className="text-3xl font-bold text-green-600 mt-1">{publishedCourses}</p>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <p className="text-sm text-gray-500">Jami talabalar</p>
                        <p className="text-3xl font-bold text-blue-600 mt-1">{totalStudents}</p>
                    </CardBody>
                </Card>
            </div>

            {/* Courses grid */}
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Kurslarim</h2>
            {courses.length === 0 ? (
                <Card>
                    <CardBody className="text-center py-12">
                        <p className="text-gray-500">Hali kurs yaratilmagan</p>
                        <Link to="/teacher/courses/create">
                            <Button className="mt-4">Birinchi kursni yarating</Button>
                        </Link>
                    </CardBody>
                </Card>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {courses.map((course) => (
                        <Link key={course.id} to={`/teacher/courses/${course.id}/edit`}>
                            <Card className="hover:shadow-md transition-shadow cursor-pointer h-full">
                                {course.image_url && (
                                    <img src={course.image_url} alt={course.title} className="w-full h-40 object-cover rounded-t-xl" />
                                )}
                                <CardBody>
                                    <div className="flex items-start justify-between mb-2">
                                        <h3 className="font-semibold text-gray-900 line-clamp-2">{course.title}</h3>
                                        <Badge variant={course.status === 'published' ? 'success' : 'warning'}>
                                            {course.status === 'published' ? 'Nashr' : 'Qoralama'}
                                        </Badge>
                                    </div>
                                    <p className="text-sm text-gray-500 line-clamp-2 mb-3">{course.description}</p>
                                    <div className="flex items-center gap-4 text-xs text-gray-400">
                                        <span>{course.modules?.length || 0} modul</span>
                                        <span>{course.enrollments_count || 0} talaba</span>
                                    </div>
                                </CardBody>
                            </Card>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
